'use strict';

module.exports = require('./lib/shallow/ReactShallowRenderer');



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-test-renderer/shallow.js
// module id = 1341
// module chunks = 3